import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Loader2, ChevronRight, Sparkles } from 'lucide-react';
import { api } from "../services/api";

type Brand = {
  id: number;
  name: string;
  image: string | null;
};

const SelectBrand: React.FC = () => {
  const navigate = useNavigate();
  const [brands, setBrands] = useState<Brand[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    api.get("/brands")
      .then((data) => setBrands(data))
      .catch(() => console.error("Failed to load brands"))
      .finally(() => setLoading(false));
  }, []);

  const filteredBrands = brands.filter(brand => 
    brand.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-[#FDFDFD] pb-24">
      
      {/* --- SLIM PROGRESS TRACKER --- */}
      <div className="bg-white border-b border-slate-100 py-3 px-6 sticky top-16 z-30">
        <div className="max-w-[1100px] mx-auto flex items-center justify-between">
           <div className="flex items-center gap-6">
              <div className="flex items-center gap-2">
                <span className="text-[10px] font-black text-[#363C90] bg-indigo-50 w-5 h-5 rounded-md flex items-center justify-center">01</span>
                <span className="text-[10px] font-black uppercase tracking-widest text-slate-900">Brand</span>
              </div>
              <ChevronRight size={12} className="text-slate-200" />
              <div className="flex items-center gap-2 opacity-30">
                <span className="text-[10px] font-black text-slate-400 bg-slate-50 w-5 h-5 rounded-md flex items-center justify-center">02</span>
                <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Model</span>
              </div>
           </div>
           <div className="flex items-center gap-2 text-[#10B981]">
              <Sparkles size={12} fill="currentColor" />
              <span className="text-[9px] font-black uppercase tracking-widest">Live Pricing</span>
           </div>
        </div>
      </div>

      <div className="max-w-[1100px] mx-auto px-6 mt-16">
        
        {/* --- HEADER --- */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-8 mb-12">
          <div>
            <h1 className="text-3xl font-black text-slate-900 mb-2 tracking-tight">
              Select <span className="text-[#363C90]">Brand</span>
            </h1>
            <p className="text-[11px] font-bold text-slate-400 uppercase tracking-wider">Choose manufacturer</p>
          </div>

          <div className="relative w-full md:w-[320px]">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300" size={16} />
            <input 
              type="text" 
              placeholder="Search e.g. iPhone"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-11 pr-4 py-3 bg-white border border-slate-200 rounded-xl outline-none focus:border-[#363C90]/30 transition-all font-bold text-sm text-slate-700 shadow-sm"
            />
          </div>
        </div>

        {/* --- BRANDS GRID --- */}
        {loading ? (
          <div className="flex justify-center py-32"><Loader2 className="animate-spin text-[#363C90]/20" size={32} /></div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {filteredBrands.map((brand) => (
              <button
                key={brand.id}
                /* FIX: Path ko HomeScreen ke format se match kiya */
                onClick={() => navigate(`/sell/products/${brand.id}?brand=${brand.name}`)}
                className="group relative bg-white border border-slate-100 rounded-2xl p-6 flex flex-col items-center justify-center hover:border-[#363C90]/20 hover:shadow-xl hover:shadow-indigo-900/5 transition-all duration-300"
              >
                <div className="w-full aspect-square mb-4 flex items-center justify-center">
                   {brand.image ? (
                      <img src={brand.image} alt={brand.name} className="max-w-[80%] max-h-[80%] object-contain transition-transform duration-500 group-hover:scale-110" />
                    ) : (
                      <span className="text-2xl font-black text-slate-200 uppercase">{brand.name.charAt(0)}</span>
                    )}
                </div>
                <p className="text-[11px] font-black text-slate-700 uppercase tracking-widest group-hover:text-[#363C90] transition-colors">
                  {brand.name}
                </p>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectBrand;